module.exports = __webpack_public_path__ + "static/media/jardim.374df35f.svg";